import { useEffect, useState } from "react";
import { clearAuthetication, fetchUserInfo } from "./userData";

// Refetches on every credential change — App needs the fresh exp claim to
// cancel the session-expired modal after a silent refresh
const useUserInfo = (credential, dispatchUserInfo) => {
  const [userInfo, setUserInfo] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!credential) return;

    let cancelled = false;
    setIsLoading(true);
    fetchUserInfo(credential)
      .then((info) => {
        if (cancelled) return;
        setIsLoading(false);
        setUserInfo(info);
        dispatchUserInfo(info);
      })
      .catch((error) => {
        console.error("Fail call api: ", error);
        if (cancelled) return;
        // Never strand the user on the boot spinner — drop the credential
        // and restart from the login screen, where One Tap signs back in
        clearAuthetication(true);
      });
    return () => {
      cancelled = true;
    };
  }, [credential, dispatchUserInfo]);

  return { userInfo, isLoading };
};

export default useUserInfo;
